export default __webpack_public_path__ + "static/CondensedRegular-84f833d440b8d86c32eb39066d5ebb3d.woff";